import { AboutClosingCta } from "@/components/about/AboutClosingCta";
import { AboutGapSection } from "@/components/about/AboutGapSection";
import { AboutHero } from "@/components/about/AboutHero";
import { AboutWaySection } from "@/components/about/AboutWaySection";
import { AlliancesSection } from "@/components/about/AlliancesSection";
import { FounderSection } from "@/components/about/FounderSection";
import { TeamSection } from "@/components/about/TeamSection";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { ABOUT_SEO } from "@/data/about";
import { Seo } from "@/lib/seo/Seo";
import { breadcrumbSchema, organizationSchema } from "@/lib/seo/schema";

export default function About() {
  return (
    <SiteLayout>
      <Seo
        title={ABOUT_SEO.title}
        description={ABOUT_SEO.description}
        path={ABOUT_SEO.path}
        jsonLd={[
          organizationSchema(),
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "About Us", path: ABOUT_SEO.path },
          ]),
        ]}
      />
      <div data-testid="about-page" className="page-main">
        <AboutHero />
        <AboutGapSection />
        <AboutWaySection />
        <FounderSection />
        <TeamSection />
        <AlliancesSection />
        <AboutClosingCta />
      </div>
    </SiteLayout>
  );
}
